export var ContactSource = /*#__PURE__*/function (ContactSource) {
  ContactSource["PrintAd"] = "Artikel oder Anzeige in Magazinen";
  ContactSource["OnlineAd"] = "Artikel oder Anzeige online";
  ContactSource["Medimarkt"] = "Medi-Markt";
  ContactSource["Unizell"] = "Unizell";
  ContactSource["Mediclean"] = "Mediclean";
  ContactSource["SocialMedia"] = "Social Media";
  ContactSource["Recommendation"] = "Weiterempfehlung";
  ContactSource["Other"] = "Sonstige";
  return ContactSource;
}(ContactSource || {});
export function getContactSourceOptions() {
  return Object.values(ContactSource).map(value => {
    return {
      value,
      label: value
    };
  });
}